<template>
  <div class="access">
    <div class="access__pic">
      <img src="@/assets/img/access-denied.svg" alt="Access denied">
    </div>
    <h1 class="access__title">Access denied</h1>
    <span class="access__text">Sorry, you don't have correct rights for this page</span>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied'
}
</script>

<style scoped lang="sass">
.access
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  height: calc(100vh - 70px)

.access__pic
  margin-bottom: 10px
  line-height: 0

.access__title
  text-align: center
  margin-bottom: 15px
  color: #181818
  font-size: 24px
  line-height: 29px
  font-weight: 600

.access__text
  text-align: center
  color: #181818
  font-size: 17px
  line-height: 20px
  font-weight: 600
</style>
